/* global axios */
import ApiClient from './ApiClient';

export const buildKontaCompanyParams = (page, sort) => {
  let params = `page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

export const buildKontaCompanySearchParams = (query, page, sort) => {
  let params = `q=${encodeURIComponent(query)}&page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

class KontaCompanyAPI extends ApiClient {
  constructor() {
    super('konta_companies', { accountScoped: true });
  }

  get(params = {}) {
    const { page = 1, sort = 'name' } = params;
    const requestURL = `${this.url}?${buildKontaCompanyParams(page, sort)}`;
    return axios.get(requestURL);
  }

  search(query = '', page = 1, sort = 'name') {
    const requestURL = `${this.url}/search?${buildKontaCompanySearchParams(query, page, sort)}`;
    return axios.get(requestURL);
  }
}

export default new KontaCompanyAPI();
